/* eslint-disable no-shadow */
import classnames from 'classnames';
import React, { useState } from 'react';
import Toggle from 'react-toggled';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Drawer from '@material-ui/core/Drawer';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Help from '@material-ui/icons/Help';
import { withTranslation } from 'react-i18next';
import ViewAgendaOutlinedIcon from '@material-ui/icons/ViewAgendaOutlined';
import ReportOutlinedIcon from '@material-ui/icons/ReportOutlined';
import KeyboardOutlinedIcon from '@material-ui/icons/KeyboardOutlined';
import BookOutlinedIcon from '@material-ui/icons/BookOutlined';
import CachedOutlinedIcon from '@material-ui/icons/CachedOutlined';
import LangSelectorContainer from '../../modules/scribe/LangSelectorContainer';
import TranslationSelector from '../../modules/scribe/TranslationSelector';
import ScribeReportModalContainer from '../../modules/scribe/ScribeReportModalContainer';
import ScribeSpeechTrainingSelectorContainer from '../../modules/scribe/ScribeSpeechTrainingSelectorContainer';
import ScribeShortcutModal from '../../modules/scribe/ScribeShortcutModal';
import { getIsMac } from '../../utils/electron';
import { styles } from '../../modules/scribe/SidebarHelpers';
import ConversationModeSelector from '../../modules/scribe/ConversationModeSelector';
import OpenOrDownloadAvaAppComponent from '../OpenOrDownloadAvaAppComponent';
import { canTranslate } from '../../utils/status';
import LanguageSwitcher from './LanguageSwitcher';
import User from './User';
import { show } from '../../utils/intercom';
import { shouldShowNewSidebarAndHeader } from '../../utils/layout';
import { firebaseLogout, getTranscriptText, switchLang, toggleAudioMode, toggleDevMode, toggleSideBar, updateBoosting, updateFullScreen, } from '../../actions';
import LogOut from './LogOut';
import ServerSettings from './ServerSettings';
import CaptionsSettings from './CaptionsSettings';
import OpenOrDownloadAva from './OpenOrDownloadAva';
import SelectMicrophone from './SelectMicrophone';
import useNetwork from '../../hooks/useNetwork';
import HomeView from './HomeView';
import ScribePreferences from './ScribePreferences';
import Link from '@material-ui/core/Link';
function index({ classes, displayable, features, firebaseUser, history, i18n, intercomDisplayed, isInConversation, sidebarShown, canTranslate, t, toggleSideBar, updateBoosting, className, electronCaptionMode, }) {
    const [openOrDownloadAvaApp, setOpenOrDownloadAvaApp] = useState(false);
    const online = useNetwork();
    let marginTop = 67;
    if (window.isElectron) {
        if (getIsMac()) {
            marginTop += 28;
        }
        else {
            marginTop += 32;
        }
    }
    if (!online && !isInConversation) {
        marginTop += 60;
    }
    const showNewSidebarAndHeader = shouldShowNewSidebarAndHeader({
        electronCaptionMode,
        firebaseUser,
        history,
        isInConversation,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: showNewSidebarAndHeader ? 'inherit' : 'none' } },
            React.createElement(HomeView, { className: classnames(className) }),
            ";"),
        React.createElement(Drawer, { classes: {
                paper: classes.drawerPaper,
            }, className: classnames('invisible-scrollbar', className), open: sidebarShown, onClose: toggleSideBar, anchor: "left", variant: "persistent", style: {
                width: sidebarShown && i18n.language === 'fr' ? 300 : null,
                display: showNewSidebarAndHeader ? 'none' : 'inherit',
            }, PaperProps: {
                style: {
                    width: sidebarShown && i18n.language === 'fr' ? 300 : null,
                    height: `calc(100% - ${marginTop}px)`,
                    marginTop,
                    visibility: 'visible',
                },
            } },
            React.createElement(List, { component: "nav", disablePadding: true },
                React.createElement(User, null),
                React.createElement(React.Fragment, null, displayable.scribeDashboard && (React.createElement(Link, { to: "/web/scribe-dashboard" },
                    React.createElement(ListItem, { key: "scribe_dashboard_toggle", role: "button", button: true },
                        React.createElement(ListItemIcon, null,
                            React.createElement(ViewAgendaOutlinedIcon, null)),
                        React.createElement(ListItemText, { classes: { root: classes.listItemText }, primary: t('sidebar.scribeDashboard') }))))),
                React.createElement(Divider, null),
                React.createElement(OpenOrDownloadAva, { setOpenOrDownloadAvaApp: setOpenOrDownloadAvaApp }),
                React.createElement(SelectMicrophone, null),
                React.createElement(CaptionsSettings, null),
                React.createElement(ScribePreferences, null),
                React.createElement(ConversationModeSelector, null),
                React.createElement("div", { style: { display: isInConversation && displayable.audio ? 'inherit' : 'none' } },
                    React.createElement(LangSelectorContainer, null)),
                React.createElement("div", { style: { display: isInConversation && canTranslate ? 'inherit' : 'none' } },
                    React.createElement(TranslationSelector, null)),
                features.scribe && React.createElement(ScribeSpeechTrainingSelectorContainer, { classes: classes }),
                features.scribe && React.createElement(Divider, null),
                features.scribe && [
                    React.createElement(Toggle, { key: "1_toggle_array" }, ({ on, getTogglerProps, setOff }) => (React.createElement(ListItem, { button: true },
                        React.createElement(ListItemIcon, null,
                            React.createElement(ReportOutlinedIcon, null)),
                        React.createElement(ListItemText, Object.assign({ classes: { root: classes.listItemText } }, getTogglerProps(), { primary: t('sidebar.reportIssue') })),
                        React.createElement(ScribeReportModalContainer, { open: on, close: setOff, old: false })))),
                ],
                features.scribe && (React.createElement(Toggle, { key: "2_toggle_array" }, ({ on: on2, getTogglerProps: getTogglerProps2, setOff: setOff2 }) => (React.createElement(ListItem, { button: true },
                    React.createElement(ListItemIcon, null,
                        React.createElement(KeyboardOutlinedIcon, null)),
                    React.createElement(ListItemText, Object.assign({ classes: { root: classes.listItemText } }, getTogglerProps2(), { primary: t('sidebar.viewShortcutList') })),
                    React.createElement(ScribeShortcutModal, { open: on2, close: setOff2 }))))),
                features.scribe && (React.createElement(ListItem, { button: true, onClick: () => {
                        window.open('https://www.notion.so/ava/Scribe-guide-fr-translated-en-7f83c1e0158b4df3b9a5dbbeca3143f0', '_blank');
                    } },
                    React.createElement(ListItemIcon, null,
                        React.createElement(BookOutlinedIcon, null)),
                    React.createElement(ListItemText, { classes: { root: classes.listItemText }, primary: t('sidebar.scribeUserGuide') }))),
                features.scribe && (React.createElement(ListItem, { key: "boost", button: true, onClick: () => updateBoosting(true) },
                    React.createElement(ListItemIcon, null,
                        React.createElement(CachedOutlinedIcon, null)),
                    React.createElement(ListItemText, { classes: { root: classes.listItemText }, primary: t('Boost') }))),
                !intercomDisplayed && (React.createElement(ListItem, { button: true },
                    React.createElement(ListItemIcon, null,
                        React.createElement(Help, null)),
                    React.createElement(ListItemText, { classes: { root: classes.listItemText }, primary: t('sidebar.contactSupport'), onClick: () => {
                            show();
                            toggleSideBar();
                        } }))),
                React.createElement(ServerSettings, null),
                React.createElement(Divider, null),
                React.createElement(LogOut, null),
                React.createElement(LanguageSwitcher, null)),
            openOrDownloadAvaApp && React.createElement(OpenOrDownloadAvaAppComponent, null))));
}
const mapStateToProps = ({ scribeConversation: { conversationStarted, inTwilioCalls, isInConversation, lang, langs, muted, scribe, status }, scribeSession: { conversations, backends, captioner, currentPlatform, displayable, features, intercomDisplayed, subscription, }, firebase: { user }, scribeTranscriptUI: { fullScreen, electronCaptionMode }, }) => ({
    conversations,
    canTranslate: canTranslate(subscription, status),
    backends,
    conversationStarted,
    currentPlatform,
    displayable,
    features,
    firebaseUser: user,
    fullScreen,
    intercomDisplayed,
    inTwilioCalls,
    isInConversation,
    lang,
    langs,
    muted,
    scribe,
    user: captioner,
    electronCaptionMode,
});
export default connect(mapStateToProps, {
    firebaseLogout,
    getTranscriptText,
    switchLang,
    toggleAudioMode,
    toggleDevMode,
    toggleSideBar,
    updateBoosting,
    updateFullScreen,
})(withTranslation()(withStyles(styles, { withTheme: true })(withRouter(index))));
